export class reportePosiciones {
	totalDistancia: number;
	posiciones: posiciones[]
}
export interface posiciones {
	fecha: string;
	ignicion: any;
	estado: any;
	velocidad: number;
	lat: number;
	lng: number;
	vehiculo: number;
	id: number;
	fechaInicial: any;
	fechaFinal: any;
	placas: any;
	economico: any
	marca: string;
	modelo: string;
	icono: string;
}
